import { render, staticRenderFns } from "./LayoutWeb.vue?vue&type=template&id=01ce8886&scoped=true&"
import script from "./LayoutWeb.vue?vue&type=script&lang=js&"
export * from "./LayoutWeb.vue?vue&type=script&lang=js&"
import style0 from "./LayoutWeb.vue?vue&type=style&index=0&id=01ce8886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ce8886",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VApp,VSheet})
